/**
 * Created by wwei on 2018-08-01.
 */

import React, { Component } from 'react';
import request from 'superagent';
import { Form, Input, Button, Select, Checkbox, Icon } from 'antd';
import moment from 'moment';
import {openNotification, NotificationType, getUrl, permissionCheck} from "../../commons/CommonUtils.js";
import Constant, {Permissions} from "../../commons/Constants.js";
import Loading from '../../commons/Loading.js';
import ConfirmDialog from '../../commons/ConfirmDialog.js';

const FormItem = Form.Item;
const Option = Select.Option;

class AppDetailFrom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            app: {
                name: '',
                scopes: [],
                callbackUrls: [''],
                properties: false
            },
            scopeOptions: []
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selected !== undefined
            && this.state.app.id !== nextProps.selected.id) {
            this.props.form.resetFields();
            if (nextProps.editMode) {
                this.setState({app: nextProps.selected});
            }
        }
    }

    componentDidMount() {
        this.getSupportScopes();
        if (this.props.editMode) {
            this.setState({app: this.props.selected});
        }
    }

    getSupportScopes = () => {
        const url = getUrl(Constant.Service.vault, "/app/scopes");
        request.get(url).withCredentials().end((err, res) => {
            if (err) {
                console.error("Failed to get supported scopes. ", err);
            } else {
                const scopes = res.body;
                const options = scopes.sort((o1, o2) => {
                    return o1.id.toLowerCase() === o2.id.toLowerCase() ? 0 : (o1.id.toLowerCase() > o2.id.toLowerCase() ? 1 : -1);
                }).map(s => {
                    return <Option key={s.id}>{s.id}</Option>;
                });
                this.setState({scopeOptions: options});
            }
        });
    }

    addField = () => {
        const app = this.state.app;
        const cbUrls = app.callbackUrls;
        cbUrls.push('');
        this.setState({app});
    }

    removeField = (index) => {
        const app = this.state.app;
        let cbUrls = app.callbackUrls;
        cbUrls.splice(index, 1);
        app.callbackUrls = cbUrls;
        this.setState({app});
    }

    getApp = app => {
        let urls = [];
        for (let key in app) {
            if (app.hasOwnProperty(key) && key.startsWith("callbackUrls_")) {
                urls.push(app[key]);
                delete app[key];
            }
        }
        app['callbackUrls'] = urls;
        app['properties'] = {isEndpoint: app['isEndpoint']};
        delete app['isEndpoint'];
        return app;
    }

    add = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, app) => {
            if (!err) {
                this.setState({saving: true});
                let newApp = this.getApp(app);

                const url = getUrl(Constant.Service.vault, "/app");
                request.post(url).withCredentials().send(newApp).end((err, res) => {
                    this.setState({saving: false});
                    if (err) {
                        console.error("Failed to add new app. ", err);
                        openNotification("Failed to add new application.", NotificationType.error);
                    } else {
                        this.props.cb(true, true, res.body);
                    }
                })
            }
        });
    }

    update = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const id = this.state.app.id;
                this.setState({saving: true});
                let newApp = this.getApp(values);

                const url = getUrl(Constant.Service.vault, "/app/" + id);
                request.put(url).withCredentials().send(newApp).end((err, res) => {
                    this.setState({saving: false});
                    if (err) {
                        console.error("Failed to add new app. ", err);
                        openNotification("Failed to update the application.", NotificationType.error);
                    } else {
                        openNotification("Succeed to update the application.", NotificationType.success);
                        this.props.cb(true, true);
                    }
                })
            }
        });
    }

    deleteApp = () => {
        const url = getUrl(Constant.Service.vault, "/app/" + this.state.app.id);
        request.delete(url).withCredentials().end((err, res) => {
            if (err) {
                console.error("Failed to delete the application. ", err);
                openNotification("Failed to delete the application.", NotificationType.error);
            } else {
                openNotification("Succeed to delete the application.", NotificationType.success);
                this.deleteModal.close();
                this.props.cb(true, true);
            }
        });
    }

    generateSecret = () => {
        const url = getUrl(Constant.Service.vault, "/app/" + this.state.app.id + "/secret");
        request.post(url).withCredentials().end((err, res) => {
            if (err) {
                console.error("Failed to delete the application. ", err);
                openNotification("Failed to generate secret.", NotificationType.error);
            } else {
                this.generateModal.close();
                this.props.cb(false, false, res.body.secret);
            }
        });
    }

    formatTime = time => {
        return moment(time).local().format("YYYY-MM-DD HH:mm:ss");
    }

    render() {
        const { saving, app, scopeOptions } = this.state;
        const { editMode, cb } = this.props;
        const formItemLayout = {
            labelCol: {sm: {span: 6}},
            wrapperCol: {sm: {span: 18}}
        };
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                sm: { span: 18, offset: 6 }
            }
        };
        const {getFieldDecorator} = this.props.form;
        const callbackUrls = (app.callbackUrls && app.callbackUrls.length > 0) ? app.callbackUrls : [''];

        const formItems = callbackUrls.map((k, index) => {
            return (
                <FormItem
                    {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                    label={index === 0 ? 'Callback URLs' : ''}
                    required={false}
                    key={index}
                    >
                    {getFieldDecorator('callbackUrls_' + index, {
                        initialValue: k
                    })(
                        <Input addonAfter={(index === callbackUrls.length - 1 && index !== 0) &&
                            <Icon type="minus-circle-o"
                                 className="dynamic-delete-button"
                                 title="Remove"
                                 onClick={() => this.removeField(index)}/>}/>
                    )}
                </FormItem>
            );
        });

        const showEdit = permissionCheck([Permissions.AppVault.EDIT]);
        const showDelete = permissionCheck([Permissions.AppVault.DELETE]);

        return (
            <div className="page-tenant-detail">
                <div className="page-close" onClick={() => cb(false, true)}>
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                </div>
                <div className='page-detail-title'>
                    <div>
                        <i className='page-detail-graphic graphic-config'></i>
                        <div className='page-detail-info'>
                            <b>{editMode ? app.name : "Create App"}</b>
                        </div>
                    </div>
                </div>
                <div className="form-horizontal" style={{paddingLeft: "30px", paddingRight: "30px", "maxWidth": "800px"}}>
                    <Form className="ant-form-horizontal">

                        {editMode && (
                            <FormItem {...formItemLayout} label="App ID">
                                {app.id}
                            </FormItem>
                        )}

                        <FormItem {...formItemLayout} label="Name">
                            {getFieldDecorator('name', {
                                initialValue: app.name,
                                rules: [{required: true, message: "This field is required."}]
                            })(
                                <Input/>
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="Short Name">
                            {getFieldDecorator('shortName', {
                                initialValue: app.shortName
                            })(
                                <Input/>
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="Scopes">
                            {getFieldDecorator('scopes', {
                                initialValue: app.scopes,
                                rules: [{type: "array"}]
                            })(
                                <Select mode="multiple" style={{ width: '100%' }} placeholder="Please select...">
                                    {scopeOptions}
                                </Select>
                            )}
                        </FormItem>

                        {formItems}
                        <FormItem {...formItemLayoutWithOutLabel}>
                            <Button type="dashed" onClick={this.addField} style={{ width: '60%' }}>
                                <Icon type="plus" />Add Callback URL
                            </Button>
                        </FormItem>

                        <FormItem {...formItemLayout} label="Properties">
                            {getFieldDecorator('isEndpoint', {
                                valuePropName: 'checked',
                                initialValue: !!app.properties.isEndpoint
                            })(
                                <Checkbox>Endpoint</Checkbox>
                            )}
                        </FormItem>
                    </Form>
                    {editMode && (
                        <div style={{margin: '40px 0 10px 0'}}>
                            Created on {this.formatTime(app.createdOn)} by {app.createdBy}.
                            Modified on {this.formatTime(app.updatedOn)} by {app.updatedBy}.
                        </div>
                    )}
                    <div className="ant-modal-footer" style={{paddingLeft: 0, paddingRight: 0}}>
                        <div className="col-lg-8" style={{textAlign: 'left', padding: 0}}>
                            {editMode ? (
                                showEdit && (
                                    <div style={{display: 'inline-block', marginRight: 8}}>
                                        <Button key="submit" type="primary" size="large" loading={saving} onClick={this.update}>
                                            Save
                                        </Button>
                                        <Button key="gen" size="large" disabled={saving} onClick={() => {this.generateModal.open()}}>
                                            Regenerate Secret
                                        </Button>
                                    </div>
                                )
                            ) : (
                                <Button key="submit" type="primary" size="large" loading={saving} onClick={this.add}>
                                    Save
                                </Button>
                            )}
                            <Button key="cancel" size="large" disabled={saving} onClick={() => cb(false, true)}>
                                Cancel
                            </Button>
                        </div>
                        {editMode && showDelete && (
                            <div className="col-lg-4" style={{padding: 0}}>
                                <Button type="danger" size="large" disabled={saving} onClick={() => {this.deleteModal.open()}}>
                                    Delete
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
                <ConfirmDialog ref={modal => {this.deleteModal = modal}}
                               title="Delete App" confirmBtnType="danger"
                               promptText={'Are you sure you want to delete this App?'}
                               cancelBtn="Cancel" confirmBtn="Delete"
                               operate={this.deleteApp}/>
                <ConfirmDialog ref={modal => {this.generateModal = modal}}
                               title="Regenerate Secret"
                               promptText={'Are you sure you want to regenerate secret for this App?'}
                               cancelBtn="Cancel" confirmBtn="Yes"
                               operate={this.generateSecret}/>
            </div>
        )
    }

}

const AppDetail = Form.create()(AppDetailFrom);
export default AppDetail;


// WEBPACK FOOTER //
// ./src/modules/appstore/AppDetail.js